import type { CountdownView } from "../runtime/useBannerCountdown";

type Copy = { title: string; text: string | null; ctaLabel: string };

/**
 * What a banner draws as its countdown runs and once it has run out: the
 * timer while it runs; then the message it ends with, keeping the CTA, or
 * the offer disabled, with no CTA. Either way the timer and the promo code
 * are gone. A banner set to hide is left out by the runtime instead.
 */
export const countdownContent = (
  { seconds, ended }: CountdownView,
  copy: Copy
) => {
  const replaced = ended?.kind === "replace" ? ended : null;

  return {
    countdown: seconds ?? undefined,
    title: replaced?.title ?? copy.title,
    text: (replaced ? replaced.text : copy.text) ?? undefined,
    ctaLabel: ended?.kind === "disable" ? undefined : copy.ctaLabel,
    /** Whether the offer still runs, so its promo code shows. */
    offerOn: !ended,
  };
};
